import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { getExternalCalendarEvents } from 'shared/services/backend-api';

export const queryKey = 'external-calendar-events';

export const useExternalCalendarEventsQuery = (
  startDate: string,
  endDate: string,
  timezone: string,
) => {
  const lastSuccessfulData = useRef<any[]>([]);

  return useQuery({
    queryKey: [queryKey, startDate, endDate, timezone],
    queryFn: async () => {
      try {
        const data = await getExternalCalendarEvents({
          startDate: new Date(startDate),
          endDate: new Date(endDate),
          timezone,
        });
        // Update the ref on success
        lastSuccessfulData.current = data;
        return data;
      } catch (e) {
        // On error, return the last successful data
        return lastSuccessfulData.current;
      }
    },
    staleTime: 5 * 60 * 1000,
    placeholderData: (previous) => previous ?? [],
  });
};
